import { claimDetailsQuery } from '@/queries/claims.queries';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

interface IOptions {
  queryOptions?: {
    claimId?: string;
    returnStatusContent?: boolean;
    returnCourierDetailsPage?: boolean;
    returnDocumentsUploadPageContent?: number;
  };
}

const useClaimDetails = (options?: IOptions) => {
  const { queryOptions = {} } = options ?? {};
  const { claimId = '' } = useParams();
  const claimDetailsQueryResult = useQuery({
    ...claimDetailsQuery({ claimId, ...queryOptions }),
    refetchInterval: 60 * 1000,
  });

  const { data: claimDetails } = claimDetailsQueryResult;

  return {
    claimDetailsQueryResult,
    claimDetails,
  };
};

export default useClaimDetails;
